import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.min.css";

import Home2Banner from "../components/Home2Banner";
import CounterBlog from "../components/CounterBlog";
import AboutServices from "../components/AboutServices";
import OurServices from "../components/OurServices";
import Gallery from "../components/Gallery";
import Testimonial from "../components/Testimonial";
import PricingTable from "../components/PricingTable";

// ⚠️ IMPORTANT: OurBlog MUST be default export
import GymFAQ from "../components/OurBlog";

import VideoBox from "../elements/VideoBox";
import Clients from "../elements/Clients";
import ContactSection from "../components/ContactSection";
import { IMAGES } from "../constants/theme";

const Home2 = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation().pathname;

  // ✅ Set theme color ONCE (correct way)
  useEffect(() => {
    document.body.setAttribute("data-theme-color", "color_2");
    localStorage.setItem("theme", "color_2");
    localStorage.setItem("themeInd", 1);
  }, [location]);

  return (
    <>
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={open}
        videoId="X_9VoqR5ojM"
        onClose={() => setOpen(false)}
      />

      <div className="page-content bg-white">
        {/* ================= Banner ================= */}
        <div className="main-bnr-three">
          <Home2Banner open={setOpen} />
        </div>

        {/* ================= About ================= */}
        <section id="about" className="about-bx4 content-inner-2">
          <div className="container">
            <AboutServices />
          </div>
        </section>

        {/* ================= Counters ================= */}
        <section className="counter-wrapper1 hpa-counter-section">
          <div className="container">
            <div className="counter-inner hpa-counter-inner">
              <div className="counter-blog-header">
                <span>Measured progress</span>
                <h2>Numbers that rise with the work.</h2>
              </div>
              <div>
                <CounterBlog />
              </div>
            </div>
          </div>
        </section>

        {/* ================= Video ================= */}
        <section
          className="content-inner-1 video-bx6 overlay-black-dark bg-img-fix"
          style={{
            backgroundImage: `url(${IMAGES.BackgroundBg1})`,
          }}
        >
          <div className="container">
            <VideoBox open={setOpen} />
          </div>
        </section>

        {/* ================= Gallery ================= */}
        <section
          className="content-inner overflow-hidden"
          style={{
            backgroundImage: `url(${IMAGES.BgImage12})`,
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container">
            <Gallery />
          </div>
        </section>


        <div className="section-head style-1 text-center hpa-plans-heading">
              <h2 className="title">
                OUR <span className="text-primary">PLANS</span>
              </h2>
            </div>
           {/* ================= Pricing ================= */}
        <PricingTable />
        {/* ================= Testimonials ================= */}
        <section
          className="content-inner-1 overflow-hidden testimonial-wrapper1"
          data-text="FEEDBACK"
          style={{
            backgroundImage: `url(${IMAGES.BgImage13})`,
            backgroundRepeat: "no-repeat",
          }}
        >
         
          <div className="container">

             {/* ================= Testimonial ================= */}
            <div className="section-head style-1 text-center">
              <h2 className="title">
                What <span>Clients</span> Say
              </h2>
            </div>
            <Testimonial />
          </div>
        </section>

        {/* ================= FAQ / Blog ================= */}
        <section
          className="content-inner-2 overflow-hidden"
          style={{
            backgroundImage: `url(${IMAGES.BgImage1})`,
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container">
            <div className="section-head style-1 text-center">
              <h2 className="title">
                Gym <span className="text-primary">FAQs</span>
              </h2>
            </div>
            <GymFAQ />
          </div>
        </section>

       

        {/* ================= Clients ================= */}
        <div className="half-shape-top-w theme-bg content-inner-1">
          <div className="container">
            <Clients />
          </div>
        </div>

        {/* ================= Contact ================= */}
        <section id="contact" className="content-inner-2" style={{ backgroundImage: `url(${IMAGES.BgImage1})`, backgroundRepeat: "no-repeat" }}>
          <ContactSection />
        </section>
      </div>
    </>
  );
};

export default Home2;
